var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangleRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2367 1.04971L0.339004 18.1918C0.160216 18.5014 0.0660731 18.8526 0.06604 19.21C0.066007 19.5675 0.160085 19.9187 0.338815 20.2283C0.517546 20.5379 0.77463 20.795 1.08422 20.9737C1.39382 21.1525 1.74501 21.2465 2.10249 21.2465H21.8963C22.2538 21.2465 22.605 21.1525 22.9146 20.9737C23.2242 20.795 23.4813 20.5379 23.66 20.2283C23.8387 19.9187 23.9328 19.5675 23.9328 19.21C23.9327 18.8526 23.8386 18.5014 23.6598 18.1918L13.7632 1.04971C13.5845 0.740204 13.3274 0.483192 13.0179 0.304501C12.7084 0.125811 12.3573 0.0317383 11.9999 0.0317383C11.6426 0.0317383 11.2915 0.125811 10.982 0.304501C10.6724 0.483192 10.4154 0.740204 10.2367 1.04971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.129 6.33667H11.8708C11.2351 6.33667 10.7198 6.85197 10.7198 7.48762V12.989C10.7198 13.6246 11.2351 14.1399 11.8708 14.1399H12.129C12.7646 14.1399 13.2799 13.6246 13.2799 12.989V7.48762C13.2799 6.85197 12.7646 6.33667 12.129 6.33667Z",
    fill: "#FFA724"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.5032C12.7068 18.5032 13.2799 17.9301 13.2799 17.2232C13.2799 16.5162 12.7068 15.9431 11.9999 15.9431C11.2929 15.9431 10.7198 16.5162 10.7198 17.2232C10.7198 17.9301 11.2929 18.5032 11.9999 18.5032Z",
    fill: "#FFA724"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleRounded);
export default __webpack_public_path__ + "static/media/warning-triangle-rounded.02eadca30639089787e24fa48834b75c.svg";
export { ForwardRef as ReactComponent };